exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.the-price h2[data-v-088bf6b8]{\n    width: 100%;\n}\n", ""]);

// exports
